import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';

export default function AboutPage() {
  return (
    <div className="min-h-screen">
      <HeroAbout />
      <BrandIntro />
      <StatsSection />
      <FAQSection />
      <ContactSection />
    </div>
  );
}

function HeroAbout() {
  return (
    <section className="relative py-16 md:py-24 overflow-hidden">
      <div className="absolute inset-0 bg-foreground-950" />
      <div className="absolute inset-0 opacity-10">
        <div className="absolute inset-0 bg-[radial-gradient(circle_at_50%_50%,oklch(0.55_0.20_25),transparent_70%)]" />
      </div>
      <div className="relative z-10 max-w-3xl mx-auto px-4 md:px-6 text-center">
        <h1 className="text-3xl md:text-4xl font-heading text-white mb-4">关于韩漫星球</h1>
        <p className="text-white/70 leading-relaxed max-w-xl mx-auto">
          韩漫星球是一个专注于韩国漫画在线阅读的平台，致力于为广大漫画爱好者提供韩漫免费、无删减漫画下拉式阅读体验
        </p>
      </div>
    </section>
  );
}

function BrandIntro() {
  return (
    <section className="py-14 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-10 items-center">
          <div>
            <span className="text-sm font-medium text-primary-500 mb-2 block">品牌介绍</span>
            <h2 className="text-2xl md:text-3xl font-heading text-foreground-950 mb-4">
              打造最好的韩漫阅读平台
            </h2>
            <p className="text-foreground-700 leading-relaxed mb-4">
              韩漫星球成立于2023年，由一群热爱韩国漫画的年轻人创立。我们深知漫画迷们对于高质量阅读体验的追求，因此我们始终坚持以用户为中心，不断优化网站性能和阅读体验。
            </p>
            <p className="text-foreground-700 leading-relaxed mb-4">
              我们的平台提供<strong>韩漫免费</strong>阅读服务，采用<strong>无删减漫画下拉式阅读</strong>模式，让你可以像在原生应用中一样流畅地浏览漫画内容。我们精心收录了<strong>好看的韩国漫画大全</strong>，涵盖恋爱、奇幻、动作、悬疑、喜剧、剧情等多种类型。
            </p>
            <p className="text-foreground-700 leading-relaxed">
              作为专业的<strong>韩漫网站</strong>，我们每天更新最新的韩国漫画章节，确保读者能够第一时间看到自己喜欢作品的最新内容。网站经过精心优化，加载速度快，浏览体验流畅。
            </p>
          </div>
          <div className="grid grid-cols-2 gap-4">
            <div className="bg-background-100 rounded-lg p-6 text-center">
              <div className="w-12 h-12 mx-auto mb-3 flex items-center justify-center rounded-full bg-primary-100 text-primary-500">
                <i className="ri-shield-check-line text-xl"></i>
              </div>
              <h3 className="text-sm font-semibold text-foreground-950 mb-1">正版授权</h3>
              <p className="text-xs text-foreground-600">与多家韩国漫画平台合作，提供正版授权内容</p>
            </div>
            <div className="bg-background-100 rounded-lg p-6 text-center">
              <div className="w-12 h-12 mx-auto mb-3 flex items-center justify-center rounded-full bg-accent-100 text-accent-500">
                <i className="ri-flashlight-line text-xl"></i>
              </div>
              <h3 className="text-sm font-semibold text-foreground-950 mb-1">极速加载</h3>
              <p className="text-xs text-foreground-600">优化的图片加载策略，阅读漫画不卡顿</p>
            </div>
            <div className="bg-background-100 rounded-lg p-6 text-center">
              <div className="w-12 h-12 mx-auto mb-3 flex items-center justify-center rounded-full bg-primary-100 text-primary-500">
                <i className="ri-smartphone-line text-xl"></i>
              </div>
              <h3 className="text-sm font-semibold text-foreground-950 mb-1">多端适配</h3>
              <p className="text-xs text-foreground-600">电脑、平板、手机均可流畅阅读</p>
            </div>
            <div className="bg-background-100 rounded-lg p-6 text-center">
              <div className="w-12 h-12 mx-auto mb-3 flex items-center justify-center rounded-full bg-accent-100 text-accent-500">
                <i className="ri-user-heart-line text-xl"></i>
              </div>
              <h3 className="text-sm font-semibold text-foreground-950 mb-1">用户至上</h3>
              <p className="text-xs text-foreground-600">用心倾听每位读者的反馈和建议</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

function StatsSection() {
  const stats = [
    { value: '500+', label: '收录漫画', icon: 'ri-book-open-line' },
    { value: '50万+', label: '活跃读者', icon: 'ri-user-line' },
    { value: '99.8%', label: '服务可用率', icon: 'ri-server-line' },
    { value: '2万+', label: '总章节数', icon: 'ri-file-list-3-line' },
  ];

  return (
    <section className="py-14 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-heading text-foreground-950">我们的数据</h2>
          <p className="text-sm text-foreground-600 mt-2">用数字说话，见证韩漫星球的成长</p>
        </div>
        <div className="grid grid-cols-2 md:grid-cols-4 gap-6">
          {stats.map(stat => (
            <div key={stat.label} className="text-center p-6 bg-background-50 rounded-lg">
              <div className="w-12 h-12 mx-auto mb-3 flex items-center justify-center rounded-full bg-accent-100 text-accent-500">
                <i className={stat.icon + ' text-xl'}></i>
              </div>
              <div className="text-2xl md:text-3xl font-bold text-foreground-950 font-heading">
                {stat.value}
              </div>
              <div className="text-sm text-foreground-600 mt-1">{stat.label}</div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

function FAQSection() {
  const faqs = [
    {
      q: '韩漫星球的漫画是免费的吗？',
      a: '是的，韩漫星球上所有漫画均为免费阅读。我们提供无删减版本的韩国漫画，采用下拉式阅读模式，无需任何付费即可畅享全部内容。',
    },
    {
      q: '漫画多久更新一次？',
      a: '我们每天都会更新最新的漫画章节。不同作品的更新频率不同，热门连载漫画通常每周更新1-2话。您可以在漫画详情页查看具体的更新时间。',
    },
    {
      q: '支持哪些设备阅读？',
      a: '韩漫星球支持电脑、平板和手机等多种设备访问。网站采用响应式设计，会自动适配不同屏幕尺寸。无论是大屏幕还是手机，都能获得良好的下拉式阅读体验。',
    },
    {
      q: '如何找到想看的漫画？',
      a: '您可以通过首页的分类导航浏览不同类型的漫画，也可以使用搜索功能直接查找。首页还有热门推荐、最新更新和排行榜等板块，帮助您发现更多好看的韩国漫画。',
    },
  ];

  return (
    <section className="py-14 md:py-20 bg-background-50">
      <div className="max-w-3xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-heading text-foreground-950">常见问题</h2>
          <p className="text-sm text-foreground-600 mt-2">关于韩漫星球，你想知道的都在这里</p>
        </div>
        <div className="space-y-3">
          {faqs.map((faq, index) => (
            <FAQItem key={index} question={faq.q} answer={faq.a} />
          ))}
        </div>
      </div>
    </section>
  );
}

function FAQItem({ question, answer }: { question: string; answer: string }) {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <div className="bg-background-100 rounded-lg overflow-hidden">
      <button
        onClick={() => setIsOpen(!isOpen)}
        className="w-full flex items-center justify-between px-5 py-4 text-left transition-colors duration-200"
      >
        <span className="text-sm font-medium text-foreground-900 pr-4">{question}</span>
        <div className={
          'w-6 h-6 flex-shrink-0 flex items-center justify-center rounded-full transition-all duration-300 ' +
          (isOpen ? 'bg-primary-500 text-white rotate-180' : 'bg-secondary-200 text-secondary-600')
        }>
          <i className="ri-arrow-down-s-line"></i>
        </div>
      </button>
      {isOpen && (
        <div className="px-5 pb-4 animate-[fadeIn_200ms_ease-out]">
          <p className="text-sm text-foreground-600 leading-relaxed">{answer}</p>
        </div>
      )}
    </div>
  );
}

function ContactSection() {
  const [formState, setFormState] = useState<'idle' | 'loading' | 'success' | 'error'>('idle');
  const [formMessage, setFormMessage] = useState('');

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    setFormState('loading');
    const form = e.currentTarget;
    const formData = new FormData(form);

    const honeypot = formData.get('phone_alt');
    if (honeypot && String(honeypot).trim() !== '') {
      setFormState('success');
      setFormMessage('感谢您的留言，我们会尽快回复！');
      form.reset();
      return;
    }
    formData.delete('phone_alt');

    try {
      const params = new URLSearchParams();
      formData.forEach((value, key) => {
        params.append(key, String(value));
      });

      const response = await fetch('https://readdy.ai/api/form/d9pdq4gsenbniolestig', {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body: params.toString(),
      });

      const responseText = await response.text();
      let parsed: any = {};
      try {
        parsed = JSON.parse(responseText);
      } catch {
        // not JSON
      }

      if (response.ok && parsed.code === 'OK') {
        setFormState('success');
        setFormMessage('感谢您的留言，我们会尽快回复！');
        form.reset();
      } else {
        const serverMsg = parsed?.meta?.message || parsed?.message || parsed?.meta?.detail || responseText || '提交失败，请稍后再试';
        if (String(serverMsg).includes('spam')) {
          setFormState('success');
          setFormMessage('感谢您的留言，我们会尽快回复！');
          form.reset();
        } else {
          setFormState('error');
          setFormMessage(typeof serverMsg === 'string' ? serverMsg : '提交失败，请稍后再试');
        }
      }
    } catch {
      setFormState('error');
      setFormMessage('网络错误，请检查连接后重试');
    }
  };

  return (
    <section className="py-14 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-10">
          <div>
            <h2 className="text-2xl md:text-3xl font-heading text-foreground-950 mb-4">联系我们</h2>
            <p className="text-sm text-foreground-600 leading-relaxed mb-8">
              如果您有任何问题、建议或合作意向，欢迎通过以下方式联系我们，我们会尽快回复。
            </p>
            <div className="space-y-4">
              <div className="flex items-start gap-3">
                <div className="w-10 h-10 flex items-center justify-center rounded-full bg-primary-100 text-primary-500 flex-shrink-0">
                  <i className="ri-mail-line"></i>
                </div>
                <div>
                  <h4 className="text-sm font-semibold text-foreground-950">电子邮箱</h4>
                  <p className="text-sm text-foreground-600">contact@manhuastar.com</p>
                </div>
              </div>
              <div className="flex items-start gap-3">
                <div className="w-10 h-10 flex items-center justify-center rounded-full bg-accent-100 text-accent-500 flex-shrink-0">
                  <i className="ri-map-pin-line"></i>
                </div>
                <div>
                  <h4 className="text-sm font-semibold text-foreground-950">办公地址</h4>
                  <p className="text-sm text-foreground-600">中国北京市朝阳区望京SOHO T2</p>
                </div>
              </div>
              <div className="flex items-start gap-3">
                <div className="w-10 h-10 flex items-center justify-center rounded-full bg-primary-100 text-primary-500 flex-shrink-0">
                  <i className="ri-time-line"></i>
                </div>
                <div>
                  <h4 className="text-sm font-semibold text-foreground-950">工作时间</h4>
                  <p className="text-sm text-foreground-600">周一至周五 9:00 - 18:00</p>
                </div>
              </div>
            </div>
            <div className="flex items-center gap-3 mt-8">
              <a href="#" className="w-10 h-10 flex items-center justify-center rounded-full bg-secondary-100 text-secondary-600 hover:bg-primary-500 hover:text-white transition-colors duration-200" rel="nofollow" aria-label="微博">
                <i className="ri-weibo-line"></i>
              </a>
              <a href="#" className="w-10 h-10 flex items-center justify-center rounded-full bg-secondary-100 text-secondary-600 hover:bg-primary-500 hover:text-white transition-colors duration-200" rel="nofollow" aria-label="微信">
                <i className="ri-wechat-line"></i>
              </a>
              <a href="#" className="w-10 h-10 flex items-center justify-center rounded-full bg-secondary-100 text-secondary-600 hover:bg-primary-500 hover:text-white transition-colors duration-200" rel="nofollow" aria-label="QQ">
                <i className="ri-qq-line"></i>
              </a>
            </div>
          </div>

          <div className="bg-background-50 rounded-lg p-6">
            <h3 className="text-lg font-heading text-foreground-950 mb-4">给我们留言</h3>
            <form onSubmit={handleSubmit} data-readdy-form="true">
              <div className="space-y-4">
                <div>
                  <label htmlFor="contact-name" className="block text-sm font-medium text-foreground-700 mb-1">姓名</label>
                  <input
                    id="contact-name"
                    name="name"
                    type="text"
                    required
                    className="w-full px-3 py-2.5 text-sm bg-background-100 border border-background-200 rounded-lg text-foreground-900 placeholder:text-foreground-400 focus:outline-none focus:border-primary-300 focus:ring-1 focus:ring-primary-200 transition-all duration-200"
                    placeholder="请输入您的姓名"
                  />
                </div>
                <div>
                  <label htmlFor="contact-email" className="block text-sm font-medium text-foreground-700 mb-1">邮箱</label>
                  <input
                    id="contact-email"
                    name="email"
                    type="email"
                    required
                    className="w-full px-3 py-2.5 text-sm bg-background-100 border border-background-200 rounded-lg text-foreground-900 placeholder:text-foreground-400 focus:outline-none focus:border-primary-300 focus:ring-1 focus:ring-primary-200 transition-all duration-200"
                    placeholder="请输入您的邮箱"
                  />
                </div>
                <div>
                  <label htmlFor="contact-message" className="block text-sm font-medium text-foreground-700 mb-1">留言内容</label>
                  <textarea
                    id="contact-message"
                    name="message"
                    required
                    rows={4}
                    maxLength={500}
                    className="w-full px-3 py-2.5 text-sm bg-background-100 border border-background-200 rounded-lg text-foreground-900 placeholder:text-foreground-400 focus:outline-none focus:border-primary-300 focus:ring-1 focus:ring-primary-200 transition-all duration-200 resize-none"
                    placeholder="请输入您的留言内容（最多500字）"
                  ></textarea>
                </div>
                <div className="honeypot-field">
                  <input
                    type="text"
                    name="phone_alt"
                    tabIndex={-1}
                    autoComplete="off"
                    aria-hidden="true"
                    readOnly
                  />
                </div>
                <button
                  type="submit"
                  disabled={formState === 'loading'}
                  className="w-full py-2.5 bg-primary-500 text-white text-sm font-medium rounded-lg hover:bg-primary-600 disabled:opacity-60 transition-colors duration-200 whitespace-nowrap"
                >
                  {formState === 'loading' ? '提交中...' : '发送留言'}
                </button>
              </div>
              {formState === 'success' && (
                <p className="mt-3 text-sm text-green-600">{formMessage}</p>
              )}
              {formState === 'error' && (
                <p className="mt-3 text-sm text-red-500">{formMessage}</p>
              )}
            </form>
          </div>
        </div>
      </div>
    </section>
  );
}